import keyboardHook from './src/hook';
import { VXETable } from '../v-x-e-table';
export var VxeModuleKeyboard = {
    install: function () {
        VXETable.hooks.add('$tableKeyboard', keyboardHook);
    }
};
export var Keyboard = VxeModuleKeyboard;
export default VxeModuleKeyboard;
